var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Backlog50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 10,
    x: 4,
    y: 7,
    fill: "#8bc34a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 10,
    x: 8,
    y: 19,
    fill: "#f44336"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 10,
    x: 4,
    y: 31,
    fill: "#ffc107"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M33,12l5,4V8L33,12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M42.164,25H37v-2h5.164C42.625,23,43,22.625,43,22.164v-8.328C43,13.375,42.625,13,42.164,13H37.5v-2 h4.664C43.728,11,45,12.272,45,13.836v8.328C45,23.728,43.728,25,42.164,25z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 7,
    y: 10,
    fill: "#388e3c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 14,
    y: 11,
    fill: "#388e3c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 11,
    y: 22,
    fill: "#d32f2f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 18,
    y: 23,
    fill: "#d32f2f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 7,
    y: 34,
    fill: "#eb8f0d"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 14,
    y: 35,
    fill: "#eb8f0d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Backlog50);
export default __webpack_public_path__ + "static/media/icons8-backlog-50.b2984903c05e49ebecf945ff8db171b9.svg";
export { ForwardRef as ReactComponent };